import m from "mithril";
export default {
  view: (vnode) =>
    m(
      "svg",
      {
        "xmlns:svg": "http://www.w3.org/2000/svg",
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.0",
        width: vnode.attrs.width,
        height: vnode.attrs.height,
        id: "svg2",
      },
      [
        m("defs", { id: "defs4" }, [
          m(
            "clipPath",
            { id: "clipPath3040" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path3042",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath3026" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path3028",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2966" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path2968",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2960" },
            m("path", {
              d: "M 593.879,103.758 L 2.588,103.758 L 2.588,736.302 L 593.879,736.302 L 593.879,103.758 z",
              id: "path2962",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2954" },
            m("path", {
              d: "M 594.75,104.228 L 0.227,104.228 L 0.227,736.764 L 594.75,736.764 L 594.75,104.228 z",
              id: "path2956",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2938" },
            m("path", {
              d: "M 574.628,123.009 L 21.839,123.009 L 21.839,420.029 L 574.628,420.029 L 574.628,123.009 z",
              id: "path2940",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2764" },
            m("path", {
              d: "M 212.368,123.009 L 85.859,123.009 L 85.859,420.029 L 212.368,420.029 L 212.368,123.009 z",
              id: "path2766",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2732" },
            m("path", {
              d: "M 574.628,123.009 L 21.839,123.009 L 21.839,420.029 L 574.628,420.029 L 574.628,123.009 z",
              id: "path2734",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2722" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path2724",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2716" },
            m("path", {
              d: "M 593.879,103.758 L 2.588,103.758 L 2.588,736.302 L 593.879,736.302 L 593.879,103.758 z",
              id: "path2718",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2710" },
            m("path", {
              d: "M 594.75,104.228 L 0.227,104.228 L 0.227,736.764 L 594.75,736.764 L 594.75,104.228 z",
              id: "path2712",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2592" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path2594",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2586" },
            m("path", {
              d: "M 593.879,103.758 L 2.588,103.758 L 2.588,736.302 L 593.879,736.302 L 593.879,103.758 z",
              id: "path2588",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2580" },
            m("path", {
              d: "M 594.75,104.228 L 0.227,104.228 L 0.227,736.764 L 594.75,736.764 L 594.75,104.228 z",
              id: "path2582",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2568" },
            m("path", {
              d: "M 167.599,420.03 L 71.343,420.03 L 71.343,571.291 L 167.599,571.291 L 167.599,420.03 z",
              id: "path2570",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2558" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path2560",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2552" },
            m("path", {
              d: "M 593.879,103.758 L 2.588,103.758 L 2.588,736.302 L 593.879,736.302 L 593.879,103.758 z",
              id: "path2554",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2546" },
            m("path", {
              d: "M 594.75,104.228 L 0.227,104.228 L 0.227,736.764 L 594.75,736.764 L 594.75,104.228 z",
              id: "path2548",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2534" },
            m("path", {
              d: "M 167.599,571.291 L 71.343,571.291 L 71.343,717.052 L 167.599,717.052 L 167.599,571.291 z",
              id: "path2536",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2520" },
            m("path", {
              d: "M 0.24994,104.228 L 594.74994,104.228 L 594.74994,736.772 L 0.24994,736.772 L 0.24994,104.228 z",
              id: "path2522",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2514" },
            m("path", {
              d: "M 593.879,103.758 L 2.588,103.758 L 2.588,736.302 L 593.879,736.302 L 593.879,103.758 z",
              id: "path2516",
            })
          ),
          m(
            "clipPath",
            { id: "clipPath2508" },
            m("path", {
              d: "M 594.75,104.228 L 0.227,104.228 L 0.227,736.764 L 594.75,736.764 L 594.75,104.228 z",
              id: "path2510",
            })
          ),
        ]),
        m(
          "g",
          {
            transform: "translate(-4.0442705e-2,0)scale(.15)",
            id: "layer1",
          },
          m(
            "g",
            {
              transform:
                "matrix(8.5309146,0,0,8.5309146,-1403.5804,-2421.7524)",
              id: "g3900",
            },
            [
              m(
                "g",
                {
                  transform: "translate(1,-0.5)",
                  id: "g3900",
                },
                m("path", {
                  d: "M 185.22295,291.49647 C 185.26295,291.47897 185.30295,291.46522 185.34545,291.45022 C 186.20545,291.14397 187.1367,290.98022 188.1042,290.98022 C 192.69045,290.98022 196.40795,294.69897 196.40795,299.28272 C 196.40795,302.18022 194.9242,304.72897 192.67795,306.21397 C 192.5917,306.27272 192.5042,306.32522 192.4192,306.37897 C 191.1592,307.14522 189.6842,307.58522 188.1042,307.58522 C 183.5192,307.58522 179.80045,303.86897 179.80045,299.28272 C 179.80045,295.71272 182.05795,292.66772 185.22295,291.49647 z M 215.6017,291.39647 L 203.8767,286.11147 C 203.5042,290.86647 202.6717,295.43647 200.6242,299.50772 C 199.8192,301.25272 198.3242,304.07522 196.51795,305.41897 C 198.17795,303.01522 198.46795,301.03772 198.46795,299.28272 C 198.46795,296.07772 197.0092,293.21022 194.7217,291.31022 C 193.7692,290.51772 192.6717,289.89147 191.4717,289.48147 C 190.41795,289.11772 189.2842,288.91897 188.1042,288.91897 C 186.82295,288.91897 185.59295,289.15397 184.4567,289.57772 C 184.4092,289.60022 184.3592,289.62147 184.3067,289.63897 C 180.4617,291.15772 177.7392,294.90272 177.7392,299.28272 C 177.7392,300.79272 178.0617,302.21647 178.64045,303.51022 C 178.64545,303.52397 178.6492,303.53147 178.65545,303.54647 C 179.1142,304.55897 179.7267,305.48272 180.46795,306.29272 C 176.8242,304.17522 171.0767,300.58397 167.2592,297.98147 C 167.25795,297.97772 167.2567,297.97772 167.2567,297.97772 C 166.69295,297.59522 166.1742,297.23522 165.70545,296.90022 L 165.70545,299.57772 C 168.0542,301.23022 170.45045,302.78022 172.88795,304.23272 C 176.8142,306.51897 180.7267,308.87272 185.1067,310.07022 C 189.1567,311.24272 194.10295,310.97897 197.9592,309.55022 C 198.8992,309.23022 199.81295,308.82397 200.7042,308.35397 C 200.8067,308.30147 200.90795,308.24772 201.0067,308.19522 C 207.4742,304.66272 212.6217,297.65022 215.6017,291.39647",
                  id: "path2842",
                  style: {
                    fill: "#ff00ff",
                    "fill-opacity": "1",
                    "fill-rule": "nonzero",
                    stroke: "none",
                  },
                })
              ),

              m("path", {
                d: "M 185.22295,291.49647 C 185.26295,291.47897 185.30295,291.46522 185.34545,291.45022 C 186.20545,291.14397 187.1367,290.98022 188.1042,290.98022 C 192.69045,290.98022 196.40795,294.69897 196.40795,299.28272 C 196.40795,302.18022 194.9242,304.72897 192.67795,306.21397 C 192.5917,306.27272 192.5042,306.32522 192.4192,306.37897 C 191.1592,307.14522 189.6842,307.58522 188.1042,307.58522 C 183.5192,307.58522 179.80045,303.86897 179.80045,299.28272 C 179.80045,295.71272 182.05795,292.66772 185.22295,291.49647 z M 215.6017,291.39647 L 203.8767,286.11147 C 203.5042,290.86647 202.6717,295.43647 200.6242,299.50772 C 199.8192,301.25272 198.3242,304.07522 196.51795,305.41897 C 198.17795,303.01522 198.46795,301.03772 198.46795,299.28272 C 198.46795,296.07772 197.0092,293.21022 194.7217,291.31022 C 193.7692,290.51772 192.6717,289.89147 191.4717,289.48147 C 190.41795,289.11772 189.2842,288.91897 188.1042,288.91897 C 186.82295,288.91897 185.59295,289.15397 184.4567,289.57772 C 184.4092,289.60022 184.3592,289.62147 184.3067,289.63897 C 180.4617,291.15772 177.7392,294.90272 177.7392,299.28272 C 177.7392,300.79272 178.0617,302.21647 178.64045,303.51022 C 178.64545,303.52397 178.6492,303.53147 178.65545,303.54647 C 179.1142,304.55897 179.7267,305.48272 180.46795,306.29272 C 176.8242,304.17522 171.0767,300.58397 167.2592,297.98147 C 167.25795,297.97772 167.2567,297.97772 167.2567,297.97772 C 166.69295,297.59522 166.1742,297.23522 165.70545,296.90022 L 165.70545,299.57772 C 168.0542,301.23022 170.45045,302.78022 172.88795,304.23272 C 176.8142,306.51897 180.7267,308.87272 185.1067,310.07022 C 189.1567,311.24272 194.10295,310.97897 197.9592,309.55022 C 198.8992,309.23022 199.81295,308.82397 200.7042,308.35397 C 200.8067,308.30147 200.90795,308.24772 201.0067,308.19522 C 207.4742,304.66272 212.6217,297.65022 215.6017,291.39647",
                id: "path2840",
                style: {
                  fill: "#00a00",
                  "fill-opacity": "1",
                  "fill-rule": "nonzero",
                  stroke: "none",
                },
              }),
            ]
          )
        ),
      ]
    ),
};
